import { Link } from 'react-router-dom';

const articleData = [
  {
    id: 1,
    title: 'What Is Kakobuy Sheet? Complete Beginner Guide 2026',
    description: 'Learn how Kakobuy Spreadsheet helps you discover trending products, compare prices, and shop smarter with organized category databases.',
    slug: '/kakobuy-spreadsheet-guide',
    imageSrc: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20home%20library%20corner%20with%20open%20book%20on%20wooden%20table%2C%20soft%20golden%20hour%20sunlight%20streaming%20through%20window%2C%20cozy%20reading%20atmosphere%2C%20cream%20walls%20with%20gentle%20shadows%2C%20lifestyle%20photography%2C%20intellectual%20warm%20aesthetic%2C%20peaceful%20quiet%20mood&width=600&height=450&seq=article-card-01-v3&orientation=landscape',
    tag: 'Beginner Guide',
  },
  {
    id: 2,
    title: 'Kakobuy Spreadsheet For Sneakers: Ultimate Sneaker Guide',
    description: 'Discover trending sneakers, compare prices across releases, and build your ultimate collection with organized research — covering hyped drops to everyday classics.',
    slug: '/kakobuy-spreadsheet-sneakers',
    imageSrc: 'https://readdy.ai/api/search-image?query=Vibrant%20sneaker%20wall%20display%20with%20colorful%20athletic%20shoes%20in%20red%20blue%20green%20and%20yellow%20arranged%20on%20industrial%20metal%20shelving%2C%20bold%20creative%20retail%20aesthetic%2C%20energetic%20street%20style%20photography%2C%20bright%20dynamic%20lighting%2C%20urban%20contemporary%20vibe&width=600&height=450&seq=article-card-02-v3&orientation=landscape',
    tag: 'Category Guide',
  },
  {
    id: 3,
    title: 'Kakobuy Spreadsheet For Fashion: Complete Style Guide',
    description: 'Master fashion product discovery across hoodies, jackets, t-shirts, pants and sets with updated pricing, style insights, and seasonal trend analysis.',
    slug: '/kakobuy-spreadsheet-fashion',
    imageSrc: 'https://readdy.ai/api/search-image?query=Artistic%20clothing%20rack%20display%20with%20earthy%20toned%20garments%20in%20olive%20rust%20beige%20and%20cream%2C%20warm%20afternoon%20light%20casting%20gentle%20shadows%2C%20minimalist%20boutique%20interior%2C%20fashion%20editorial%20style%2C%20soft%20natural%20tones%2C%20elegant%20relaxed%20composition&width=600&height=450&seq=article-card-03-v3&orientation=landscape',
    tag: 'Fashion',
  },
  {
    id: 4,
    title: 'Kakobuy Spreadsheet For Electronics: Tech Research',
    description: 'Navigate electronics with organized specs, price comparisons and community reviews — covering audio gear, gaming accessories, and smart devices.',
    slug: '/kakobuy-spreadsheet-electronics',
    imageSrc: 'https://readdy.ai/api/search-image?query=Futuristic%20tech%20workspace%20with%20glowing%20LED%20keyboard%20wireless%20earbuds%20and%20smartwatch%20on%20dark%20matte%20surface%2C%20cool%20blue%20ambient%20lighting%2C%20cyberpunk%20inspired%20product%20photography%2C%20sleek%20modern%20aesthetic%2C%20sharp%20reflections%20on%20polished%20desk&width=600&height=450&seq=article-card-04-v3&orientation=landscape',
    tag: 'Tech',
  },
  {
    id: 5,
    title: 'Best Kakobuy Spreadsheet Finds: Top Rated Products',
    description: 'A curated roundup of the highest-rated product discoveries across sneakers, fashion, electronics, and accessories loved by the spreadsheet community.',
    slug: '/kakobuy-spreadsheet-best-finds',
    imageSrc: 'https://readdy.ai/api/search-image?query=Premium%20product%20flat%20lay%20with%20leather%20goods%20gold%20accessories%20and%20designer%20items%20arranged%20on%20rich%20dark%20wood%20surface%2C%20dramatic%20spotlight%20lighting%20creating%20elegant%20shadows%2C%20luxury%20editorial%20photography%2C%20sophisticated%20exclusive%20aesthetic&width=600&height=450&seq=article-card-05-v3&orientation=landscape',
    tag: 'Top Picks',
  },
  {
    id: 6,
    title: 'CSSBuy Spreadsheet: Complete Shopping Database Guide',
    description: 'Compare CSSBuy spreadsheet tools, product categories, and learn how to maximize your shopping research efficiency with organized databases.',
    slug: '/cssbuy-spreadsheet-guide',
    imageSrc: 'https://readdy.ai/api/search-image?query=Organized%20creative%20studio%20with%20cork%20board%20covered%20in%20fashion%20sketches%20and%20fabric%20swatches%2C%20natural%20daylight%20from%20large%20windows%2C%20artistic%20workspace%20atmosphere%2C%20warm%20industrial%20interior%2C%20creative%20process%20photography%2C%20authentic%20maker%20vibe&width=600&height=450&seq=article-card-06-v3&orientation=landscape',
    tag: 'Comparison',
  },
];

export default function ArticlePreview() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-block text-xs font-medium text-secondary-600 uppercase tracking-wider mb-3">
              Latest Research
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight">
              Fresh Research Guides
            </h2>
          </div>
          <p className="text-sm text-foreground-500 mt-2 sm:mt-0">
            Updated product lists &amp; buying tips
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articleData.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageSrc}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-primary-600 whitespace-nowrap">
                    {article.tag}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-foreground-900/70 to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}